"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-console */
const package_1 = require("~build/package");
const time_1 = __importDefault(require("~build/time"));
const ci_1 = require("~build/ci");
const git_1 = require("~build/git");
const printBuildInfo = () => {
    if (process.env.NODE_ENV === 'development') {
        return;
    }
    console.group('Build info');
    console.log('Project:', package_1.name);
    console.log('Build date:', time_1.default ? time_1.default.toLocaleString() : 'Unknown');
    console.log('Environment:', `${process.env.NODE_ENV}${ci_1.isCI ? '(ci)' : ''}`);
    console.log('Version:', `${package_1.version}-${git_1.abbreviatedSha}`);
    console.log(`This is an open source project, you can view its source code on Github!`);
    git_1.github && console.log(`${git_1.github}/tree/${git_1.abbreviatedSha}`);
    console.groupEnd();
};
printBuildInfo();
